import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Clock } from 'lucide-react';

// LinkedIn icon component since lucide-react doesn't have it
const LinkedInIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_189a4100-90ea-4234-8592-108cc00e468b/artifacts/q72i6epx_IMG_8643.jpeg" 
              alt="City Central Pharmacy" 
              className="h-12 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-sm mb-4">
              Your trusted community pharmacy providing quality healthcare and medicines 24/7 across Accra.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/share/14VM4xr6EqR/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors"
              >
                <Facebook className="w-4 h-4 text-white" />
              </a>
              <a 
                href="https://www.instagram.com/citycentralpharma?igsh=azh4NTljM2RsbXQ2" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors"
              >
                <Instagram className="w-4 h-4 text-white" />
              </a>
              <a 
                href="https://www.linkedin.com/company/city-central-pharmacy/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors"
              >
                <LinkedInIcon className="w-4 h-4 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-orange-500 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Our Services</Link></li>
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Products</Link></li>
              <li><Link to="/branches" className="hover:text-orange-500 transition-colors">Find a Branch</Link></li>
              <li><Link to="/blog" className="hover:text-orange-500 transition-colors">Health Tips</Link></li>
              <li><Link to="/insurance-prescription" className="hover:text-orange-500 transition-colors">Upload Insurance Prescription</Link></li>
              <li><Link to="/careers" className="hover:text-orange-500 transition-colors">Careers</Link></li>
              <li><Link to="/faqs" className="hover:text-orange-500 transition-colors">FAQs</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Prescription Dispensing</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">OTC Medicines</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Home Delivery</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">Health Consultation</li>
              <li className="hover:text-orange-500 transition-colors cursor-pointer">24-Hour Service</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span>Spintex, Okpoi Gonno,<br />Accra, Ghana</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a href="tel:+233539543737" className="hover:text-orange-500 transition-colors">0539543737</a>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="font-semibold text-yellow-400">Open 24 Hours</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-6 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} City Central Pharmacy. All rights reserved.</p>
          <p className="mt-2 text-gray-500">Trusted Community Pharmacy | Quality Healthcare for All</p>
        </div>
      </div>
    </footer>
  );
};
